/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { useMediaQuery, useUser } from 'hooks';
import { Text, TextLight } from 'components/Texts';
import { Hollow } from 'components/Buttons';
import {
  colors, Figure, Div, weight,
} from 'globalStyle';
import { ErrorText } from 'components/Form';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import closeIcon from 'assets/icons/closeIcon.svg';

export const PayInfo = ({
  setModal,
  isOpen,
  handleClose,
  goToBack,
  handleSuccess,
  ...props
}) => {
  const isDesktop = useMediaQuery();
  const [errorMessage] = useState(null);

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: { borderRadius: '20px', padding: '30px' },
      }}
      maxWidth="sm"
      onClick={(e) => e.stopPropagation()}
    >
      <DialogContent
        style={{
          width: `${isDesktop ? 'calc(560px - 60px)' : 'auto'}`,
          padding: '0',
          overflowY: 'initial',
        }}
        align="center"
      >
        <Div isFlex justify="space-between" margin="0 0 20px">
          <Figure
            style={{
              width: '25px',
              height: '25px',
              cursor: 'pointer',
            }}
          />
          <Div>
            <TextLight
              pr={5}
              pl={5}
              weight={weight.BOLD}
              color={colors.primary}
              size={isDesktop ? 20 : 16}
            >
              Actualización sobre tus retiros
            </TextLight>
          </Div>
          <Figure
            style={{
              width: '18px',
              height: '18px',
              cursor: 'pointer',
            }}
            onClick={() => {
              handleClose();
            }}
          >
            <img src={closeIcon} alt="cerrar" />
          </Figure>
        </Div>
        <Div p={`${isDesktop ? '0 30px' : '0 10px'}`}>
          <Text whiteSpace="normal" mb={40} mt={40} lineHeight="17.5px" size={13}>
            Estimado/a inversionista, para garantizar la máxima seguridad en tus transacciones,
            actualmente estamos ajustando nuestros protocolos de retiro.
            <br />
            <br />
            Tu retiro se verá reflejado en tu cuenta bancaria en aproximadamente 8 días hábiles.
            Lamentamos cualquier inconveniente que este tiempo de espera adicional pueda causarte;
            trabajamos para restablecer nuestro servicio a la velocidad habitual lo antes posible.
            <br />
            <br />
            Gracias por confiar en nosotros.
          </Text>
          <ErrorText isCenter text={errorMessage} />
          <Div>
            <Hollow
              style={{ width: `${isDesktop ? '330px' : '100%'}` }}
              isSubmit
              onColorType="primary"
              onClick={handleSuccess}
              size="14px"
              padding="7px 0"
            >
              Entendido
            </Hollow>
          </Div>
        </Div>
      </DialogContent>
    </Dialog>
  );
};
